<template>
    <v-dialog
        ref="dialog"
        v-model="modal"
        :return-value.sync="date"
        width="350px"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-text-field
                dense
                outlined
                hide-details="auto"
                readonly
                clearable
                :label="title"
                :value="rangeView"
                v-bind="attrs"
                v-on="on"
                @click:clear="OnClear"
            ></v-text-field>
        </template>
        <v-card>
            <v-card-title>
                <span class="headline">{{ title }}</span>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-date-picker
                        v-model="date"
                        scrollable
                        range
                        no-title
                        :min="dateLimit.min"
                        :max="dateLimit.max"
                    ></v-date-picker>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="Save()" class="primary white--text" depressed>
                    <v-icon left>save</v-icon>
                    {{ $t('Save') }}
                </v-btn>
                <v-btn color="blue darken-1" text @click="modal = false">{{
                    $t('Cancel')
                }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import VWmFormDialog from '@/component/form-dialog.vue';
import { getDateStr } from '@/script/common';

export default {
    components: {
        VWmFormDialog,
    },
    props: {
        label: String,
        limitFourDay: Boolean
    },
    data() {
        return {
            date: null,
            modal: false
        };
    },
    computed: {
        title() {
            return this.label || this.$t('Date_Range');
        },
        rangeView() {
            if (this.date && this.date.length > 0) {
                this.date.sort();
                let start = getDateStr(new Date(this.date[0]));
                let end = getDateStr(
                    new Date(
                        this.date.length === 1 ? this.date[0] : this.date[1]
                    )
                );
                return `${start} - ${end}`;
            }
            return null;
        },
        dateLimit() {
            if(this.limitFourDay && this.date && this.date[0] && !this.date[1]) {
                const minDate = new Date(new Date(this.date[0])
                    .setDate(new Date(this.date[0]).getDate() - 3))
                    .toISOString()
                    .slice(0, 10);
                const maxDate = new Date(new Date(this.date[0])
                    .setDate(new Date(this.date[0]).getDate() + 3))
                    .toISOString()
                    .slice(0, 10);
                return {
                    min: minDate,
                    max: maxDate
                }
            } else {
                return {}
            }
        }
    },
    methods: {
        Save() {
            if (this.date) {
                if (this.date.length === 1) {
                    this.date.push(this.date[0]);
                } else if (this.date.length < 1) {
                    this.$emit('input', { start: null, end: null });
                    this.modal = false;
                    return;
                }
            } else {
                this.$emit('input', { start: null, end: null });
                this.modal = false;
                return;
            }
            this.date.sort();
            this.$refs.dialog.save(this.date);
            this.$emit('input', {
                start: this.date[0],
                end: this.date[1],
            });
        },
        OnClear() {
            this.$emit('input', { start: null, end: null });
        },
    },
};
</script>

<style>
</style>
